export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: 80,
    visible: !that.disabled,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_contactName') || '联系人',
    field: 'contactName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 160,
    editRender: {
      name: 'ElInput',
      props: {
        maxlength: 100,
        placeholder: that.$l('INDEX.tips_input_placeholder') || '请输入...',
        disabled: that.disabled,
        clearable: true,
      },
    },
  },
  {
    title: that.$l('table_label_contactMobile') || '手机号',
    field: 'contactMobile',
    headerAlign: 'center',
    align: 'left',
    minWidth: 160,
    editRender: {
      name: 'ElInput',
      props: {
        maxlength: 100,
        placeholder: that.$l('INDEX.tips_input_placeholder') || '请输入...',
        disabled: that.disabled,
        clearable: true,
      },
    },
  },
  {
    title: that.$l('table_label_contactPhone') || '固定电话',
    field: 'contactPhone',
    headerAlign: 'center',
    align: 'left',
    minWidth: 160,
    editRender: {
      name: 'ElInput',
      props: {
        maxlength: 100,
        placeholder: that.$l('INDEX.tips_input_placeholder') || '请输入...',
        disabled: that.disabled,
        clearable: true,
      },
    },
  },
  {
    title: that.$l('table_label_contactEmail') || '联系人Email',
    field: 'contactEmail',
    headerAlign: 'center',
    align: 'left',
    minWidth: 160,
    editRender: {
      name: 'ElInput',
      props: {
        maxlength: 100,
        placeholder: that.$l('INDEX.tips_input_placeholder') || '请输入...',
        disabled: that.disabled,
        clearable: true,
      },
    },
  },
  {
    title: that.$l('table_label_contactJob') || '联系人职务',
    field: 'contactJob',
    headerAlign: 'center',
    align: 'left',
    minWidth: 160,
    editRender: {
      name: 'ElInput',
      props: {
        maxlength: 100,
        placeholder: that.$l('INDEX.tips_input_placeholder') || '请输入...',
        disabled: that.disabled,
        clearable: true,
      },
    },
  }, {
    field: 'modifyByName',
    align: 'left',
    width: 170,
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    showHeaderOverflow: true,
    slots: { default: 'modifyInfo' },
  },
]
